import useAuth from 'hooks/useAuth';

import Logo from 'components/Logo';
import Spinner from 'components/Spinner';

import AuthApp from 'app/AuthApp';
import MainApp from 'app/MainApp';

import 'app/App.scss';
import {useEffect, useState} from 'react';
import PaymentForm from 'pages/PaymentForm';
// import Onboarding from './Onboarding';
import styles from './Logo.module.scss';
function Loading() {
  return (
    <div className="content --full-width --center --column">
      {/* <Logo / */}
      <div className={styles.brand}>
        <div className={styles.logo}>
          <Logo style={{width: 100, height: 100, filter: 'invert(0)'}} />
        </div>
      </div>
      <Spinner />
    </div>
  );
}

function useApp() {
  const {loading, currentUser} = useAuth();
  const [paymentId, setPaymentId] = useState('');

  useEffect(() => {
    if (window.location.pathname.endsWith('/payment')) {
      const id = window.location.href.split('id=')[1];
      setPaymentId(id);
    }
  }, []);

  if (paymentId) {
    return <PaymentForm id={paymentId} />;
  }

  if (loading) return <Loading />;

  if (currentUser) {
    return <MainApp />;
    // if (currentUser.is_onboarded) {
    // } else {
    //   return <Onboarding />;
    // }
  } else {
    return <AuthApp />;
  }
}

function App() {
  const app = useApp();
  return <div className="App">{app}</div>;
}

export default App;
